import { api } from '@/plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    activiteReservee: {
      id: null,
      pp: null,
      demandeInscription: null,
      pratiqueActivite: null,
      statutCompletion: null,
      active: true,
      activiteAdoptionHorsQuebec: null,
      activitesReservees: [],
    }
  }
}


const state = getDefaultState()

const getters = {
  getActiviteReservee: (state) => {
    return state.activiteReservee
  }
}

const mutations = {
  setStatutCompletion(state, value) {
    state.activiteReservee.statutCompletion = value;
  },
  setId(state, id) {
    state.activiteReservee.id = id
  },
  setActiviteReservee(state, dto) {
    state.activiteReservee = { ...dto }
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getActiviteReserveeByDemandeInscriptionId({ commit }, demandeInscriptionId) {
    const response = await api.get(`activitereserveepl18/demandesinscriptions/` + demandeInscriptionId);
    commit("setActiviteReservee", response.data[0] ? response.data[0] : getDefaultState().activiteReservee)
  },
  async getActiviteReserveeByContactId({ commit }, contactId) {
    const response = await api.get(`activitereserveepl18/contacts/` + contactId);
    commit("setActiviteReservee", response.data && response.data ? response.data : getDefaultState().activiteReservee)
    return response
  },
  async createActiviteReservee({ commit }, dto) {
    dto.id = null
    const response = await api.post(`activitereserveepl18`, dto);
    commit('setId', response.data);
  },
  async updateActiviteReservee({ commit }, dto) {
    const response = await api.put(`activitereserveepl18`, dto);
    commit('setActiviteReservee', response.data ? response.data : null);
  },
  resetModuleState({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})